export default __webpack_public_path__ + "Section 3 Planning Guide.docx";